import { SwingLabVideo } from '../data/useRecentVideos';

export const SWING_LAB_LIMITS = {
  maxDurationSec: 20,
  maxResolutionWidth: 3840,
  maxResolutionHeight: 2160,
} as const;

export function isWithinSwingLabLimits(video: SwingLabVideo): boolean {
  // Check duration
  if (video.durationSec && video.durationSec > SWING_LAB_LIMITS.maxDurationSec) {
    return false;
  }

  // Check resolution (allow up to 4K in any orientation)
  if (video.resolution) {
    const [widthStr, heightStr] = video.resolution.split('x');
    const width = parseInt(widthStr, 10);
    const height = parseInt(heightStr, 10);
    
    const longEdge = Math.max(width, height);
    const shortEdge = Math.min(width, height);
    
    if (longEdge > SWING_LAB_LIMITS.maxResolutionWidth || shortEdge > SWING_LAB_LIMITS.maxResolutionHeight) {
      return false;
    }
  }

  return true;
}

export function getLimitWarningMessage(video: SwingLabVideo): string | null {
  const violations: string[] = [];
  
  if (video.durationSec && video.durationSec > SWING_LAB_LIMITS.maxDurationSec) {
    violations.push(`${video.durationSec}s > ${SWING_LAB_LIMITS.maxDurationSec}s`);
  }
  
  if (video.resolution) {
    const [widthStr, heightStr] = video.resolution.split('x');
    const width = parseInt(widthStr, 10);
    const height = parseInt(heightStr, 10);
    
    const longEdge = Math.max(width, height);
    const shortEdge = Math.min(width, height);
    
    if (longEdge > SWING_LAB_LIMITS.maxResolutionWidth || shortEdge > SWING_LAB_LIMITS.maxResolutionHeight) {
      violations.push(`${video.resolution} > 4K`);
    }
  }
  
  return violations.length > 0 
    ? `Outside Swing Lab limits (${violations.join(', ')})` 
    : null;
}